<template>
  <div class="wrap">
    <div class="banner">
      <img src="@/assets/image/exportbanner.jpg" style="width: 100%" alt="" />
    </div>
    <div class="pagew">
      <!-- <Header activeIndex="/export" /> -->
      <div class="content">
        <div class="title">历届大赛专家评审团介绍</div>
        <div class="cont">
          历届大赛的评委专家库中包括国内外知名高校设计专业博士、教授及知名设计机构与企业的设计总监等。大赛组织方每界大赛都邀请业内知名教授专家、知名设计大师、龙头企业家 投资机构掌门人等组成的终评评审委员会，聘请国内外顶尖设计大师或教授担任评委会主席。其中包括至少两名德国红点奖/IF奖评委，工业设计领域、产业集群领域、创投领域等资深专家共5-7名委员。2019年德国IF国际工业设计大赛 全球CEO拉尔夫·维格曼先生为创客广东评委会主席，2020年创客广东由湖南大学设计艺术学院教授、国务院学位委员会设计学科评议组成员、教育部高等学校工业设计专业教学指导分委员会主任委员何人可教授担任主席。
        </div>
      </div>
      <div class="imgbox">
        <div class="box">
          <div class="boxitem" v-for="(item, index) in finishList" :key="index">
            <div class="onde" style="background-color: #f5f1e5;height: 320px;overflow:hidden;">
              <div class="img" :style="{'background-image': `url(http://admin.gdsme.org/prod-api${item.expePhoto}`}" />
              <!-- <img v-if="item.expePhoto" :src="`http://admin.gdsme.org/prod-api${item.expePhoto}`" alt="" style="width: 100%;" /> -->
              <div class="special" v-if="item.show">
                <div class="specials"></div>
                <div class="info">
                  <div class="name">{{ item.expeName }}</div>
                  <div class="imfor">{{item.expePost}}</div>
                </div>
                <div class="company">单位：{{ item.expeWorkUnit }}</div>
                <!-- <div class="company">{{ item.position }}</div> -->
              </div>
              <div class="label" v-if="!item.show">
                <div class="name">{{ item.expeName }}</div>
                <div class="position">{{ item.expePost }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="imgboxs" v-if="false">
        <div class="boxs">
          <div class="boxitems" v-for="(item, index) in reviewList" :key="index">
            <div class="ondes" style="height: 280px;background: #f5f1e5;overflow: hidden;">
              <img v-if="item.expePhoto" :src="`http://admin.gdsme.org/prod-api${item.expePhoto}`" alt="" style="width: 100%;" />
              <div class="label">
                <div class="name">{{ item.expeName }}</div>
                <div class="position text-overflow">单位：{{ item.expeWorkUnit }}</div>
                <div class="position text-overflow">职位：{{ item.expePost }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer/index";
import Header from "@/components/Header/Header";
import * as request from "@/api/api.js";
import { getExportList } from "@/api/api.js";
export default {
  name: "exports",
  // components: { Footer, Header },
  data() {
    return {
      finishList: [],
      reviewList: [],
      activeIndex: "1",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSelect() {},
    //  请求专家列表
    getList() {
      request.getExportList({pageNum: 1, pageSize: 999}).then((res) => {
        this.finishList = (res.data).rows || [];
      });
      // request.getExportList({pageNum: 1, pageSize: 999, expeType: '4'}).then((res) => {
      //   console.log(res);
      //   this.finishList = (res.data).rows || [];
      // });
    },
  },
};
</script>

<style scoped lang="scss">
.el-menu-item.is-active {
  border-bottom: 2px solid red !important;
  color: red !important;
  font-weight: bold;
}

.el-menu-item {
  padding: 0 43px;
}
.wrap {
  text-align: left;
  width: 100%;

  .banner {
    width: 100%;
    z-index: -2;
    // height: 600px;
    // background: url('../../assets/image/exportbanner.png') no-repeat center top;
    background-size: 100% auto;
  }

  .content {
    // width: 65%;
    // margin: 0 auto;
    margin-top: 40px;
    padding-bottom: 40px;

    .title {
      width: 100%;
      text-align: center;
      padding: 20px 0;
      font-weight: bold;
    }

    .cont {
      text-indent: 2em;
      font-size: 14px;
      line-height: 25px;
    }
  }

  .select {
    height: 80px;
    width: 35%;
    margin: 0 auto;
  }

  // 评委样式
  .imgbox {
    .box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .boxitem {
        width: 24%;margin: 0 .5%;
        padding-bottom: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        .onde {
          cursor: pointer;
          position: relative;
          width: 100%;
          height: 320px;
          background-color: #be2021;
          color: #ffffff;
          // display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          font-size: 12px;
          &:hover {
            .label {
              background-color: rgba(190, 32, 33, 0.9);bottom: 10px;color: #fff;
            }
            .label::before {display: block;}
          }
          .special {
            // width: 80%;
            height: 100px;
            background-color: rgba(190, 32, 33, 0.9);
            border-radius: 8px;
            position: absolute;
            bottom: 10px;
            color: #000000;
            .specials {
              position: absolute;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border: 10px solid transparent;
              border-bottom-color: rgba(190,32,33,0.9);
            }
            .info {
              margin-top: 10px;
              width: 100%;
              display: flex;
              color: #ffffff;
              .name {
                width: 50%;
                text-align: center;
                font-size: 16px;
              }
              .imfor {
                line-height: 25px;
                text-align: center;
                font-size: 12px;
              }
            }
            .company {
              display: none;
              color: #fff;
              margin-left: 16px;
              padding: 5px 0;
            }
          }

          .label {
            position: relative;
            transition: bottom .25s;
            width: 80%;
            height: 80px;
            background-color: rgba($color: #fff, $alpha: .8);
            border-radius: 8px;
            position: absolute;
            bottom: 0;
            display: flex;
            align-items: center;
            color: #000000;
            left: 10%;
            .name {
              text-align: center;
              width: 90px;
              font-size: 14px;
            }
            .position {
              text-align: center;
              font-size: 12px;
              flex: 1;
            }

            &::before {
              display: none;
              content: '';
              position: absolute;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border: 10px solid transparent;
              border-bottom-color: rgba(190,32,33,0.9);
            }
          }
          div {
            // width: 90%;
          }
        }
      }
    }
  }

  .imgboxs {
    .boxs {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .boxitems {
        width: 20%;
        padding-bottom: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        .ondes {
          position: relative;
          width: 90%;
          height: 280px;
          background-color: #be2021;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          font-size: 12px;
          .label {
            width: 80%;
            height: 75px;
            background-color: #ecedf1;
            border-radius: 8px;
            position: absolute;
            bottom: 0;
            color: #000000;
            .name {
              text-align: center;
              font-size: 14px;
              font-weight: bold;
              padding: 6px 0;
            }
            .position {
              width: 90%;
              margin: 0 auto;
              text-align: left;
              font-size: 12px;
              padding-bottom: 5px;
              color: gray;
            }
          }
          div {
            width: 90%;
          }
        }
      }
    }
  }
}
.img {
  // aspect-ratio: 282/199;
  width: 100%;
  height: 250px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/view/Export/index.vue